import Form from '../../../../../form_builder_2/form';
import AnalyticsHelper from '../../../../../utils/analytics-helper';

export default class RegisterSendOTP {
    constructor(parent) {
        this.parent = parent;
        this.modal = parent.parent;
        this.el = parent.el.querySelector('.register-send-otp-tab');
        this.tabLink = parent.el.querySelector('.register-send-otp-tab-link');
        this.input = this.el.querySelector('input[name=email]');
        this.form = new Form(this.el.querySelector('.register-send-otp-form'), {
            onSuccess: this.onSuccess.bind(this),
            onError: this.onError.bind(this),
        });
        this.forgotPassword = this.el.querySelector('.forgot-password');
        this.bind();
    }

    submit(cbs){
        this.form.submit(true, cbs);
    }

    bind() {
        this.tabLink.addEventListener('click', (e) => {
            e.preventDefault();
            this.modal.show({ view: 'login', tab: 'register' });
            this.modal.el.querySelector('input[name="email"]').focus({ preventScroll: true });
        });

        this.forgotPassword.addEventListener('click', (e) => {
            e.preventDefault();
            this.modal.show({ view: 'password-send-otp' });
        });
    }

    onSuccess(result) {
        this.modal.views['register-validate-otp'].populate({
            otpId: result.id,
            correlation: result.correlation,
            email: this.input.value,
        });
        this.modal.show({ view: 'register-validate-otp' });
        this.analyticsPush(result);
    }

    onError(result) {
        this.form.showError();
    }

    show() {
        this.el.classList.remove('hide');
        this.tabLink.classList.add('active');
    }

    hide() {
        this.el.classList.add('hide');
        this.tabLink.classList.remove('active');
    }

    analyticsPush(result) {
        this.loginStatus = result.success;

        AnalyticsHelper.push({
            event: 'my_account',
            eventCategory: 'my account',
            eventAction: 'Registration start',
            eventLabel: `${dataLayer[0].productCategory }|My account|Submit|internal|email id submitted|#`,
            actionType: 'Registration start',
            businessUnit: `${dataLayer[0].productCategory }`,
            moduleName: 'My account',
            clickText: 'Submit',
            clickType: 'internal',
            registrationStep: 'email id submitted',
            destinationURL: '#',
        });
    }
}
